<template>
    <div style="position: relative">
        <!-- <div class="absolute-share">
           
            <a
                class="twitter-share-button"
                :href="
                    `https://twitter.com/intent/tweet?url=http://tournaments.outpostchess.com/` +
                    tournament.event_slug +
                    `&text=` +
                    tournament.event_name
                "
                data-size="large"
            >
                <img class="social-share-btn" src="@/assets/Social/Xtvit.svg" alt="" />
            </a>
            <button>
        <ShareNetwork
            network="facebook"
            :url= "`http://tournaments.outpostchess.com/` +
                    tournament.event_slug "
            
            hashtags="Chess,Tournament">
            <span>
                <img
                    class="social-share-btn"
                    src="@/assets/Social/face.png"
                    width="22px"
                    height="22px"
                    alt="Share on Facebook"
                />
            </span>
        </ShareNetwork>
    </button>
    
           
        </div> -->
    </div>
</template>

<script>
export default {
    name: "ShareTournament",
    components: {},
    props: ["tournament"],
    data() {
        return {};
    },
    // metaInfo: {
    //     title: " SPA Metadata",
    //     description: "How to configure popular SPA frameworks to maintain quality site metadata.",
    //     url: "",
    // },

    mounted() {},
    methods: {},
};
</script>

<style scoped lang="scss">
.twitter-share-button {
    &:hover {
        opacity: 0.7;
    }
}
.absolute-share {
    position: absolute;
    display: flex;
    top: -30px;
}
.social-share-btn {
    width: 20px;
    height: 20px;
    margin-bottom: 10px;
    margin-right: 12px;
}
@media screen and (max-width: 640px) {
}
</style>
